var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 87.5,
    viewBox: "0 0 100 87.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.625,50H9.375a9.375,9.375,0,0,0,0,18.75h81.25a9.375,9.375,0,0,0,0-18.75ZM93.75,75H6.25a3.125,3.125,0,0,0-3.125,3.125V81.25a12.5,12.5,0,0,0,12.5,12.5h68.75a12.5,12.5,0,0,0,12.5-12.5V78.125A3.125,3.125,0,0,0,93.75,75Zm-82.3-31.25H88.547c6.752,0,10.668-8.574,6.8-14.82C87.5,16.25,70.225,6.27,50,6.25c-20.223.02-37.5,10-45.348,22.678C.781,35.174,4.7,43.75,11.453,43.75ZM75,21.875A3.125,3.125,0,1,1,71.875,25,3.125,3.125,0,0,1,75,21.875Zm-25-6.25a3.125,3.125,0,1,1-3.125,3.125A3.125,3.125,0,0,1,50,15.625Zm-25,6.25A3.125,3.125,0,1,1,21.875,25,3.125,3.125,0,0,1,25,21.875Z",
    transform: "translate(0 -6.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipes);
export default __webpack_public_path__ + "static/media/recipes.77d39efce6392fb1989e133d44f2d847.svg";
export { ForwardRef as ReactComponent };